import { IncorporationStatusStepper } from 'components/IncorporationStatus/IncorporationStatusStepper';
import { IAccount } from 'models/account';
import { useUserPreference } from 'hooks/api';
import { Alert, Box, Skeleton, Typography } from '@mui/material';
import { UserPreferenceSetting } from 'components/IncorporationStatus/UserPreferenceSetting';
import { useAutoInitIncorporationStatus } from 'components/IncorporationStatus/utils';
import { ENTITY_MAPPING } from 'constants/common';
import { Business } from 'models/business';

interface UIProps {
  email?: string;
  business: Business;
  userId: string;
}

export const IncorporationStatusUI = ({
  email,
  userId,
  business,
}: UIProps) => (
  <Box sx={{ mb: 3 }}>
    <Typography
      variant="subtitle1MB"
      color="primary.main"
      sx={{ mt: 2, mb: 2, textAlign: 'center' }}
      component="h2"
    >
      Your Incorporation Progress
    </Typography>
    <Box sx={{ p: 3 }}>
      <IncorporationStatusStepper business={business} />
      {business.bibHubspot?.ticketStatus === 'ACTION_NEEDED' && (
        <Alert severity="warning" icon={false} sx={{ mt: 2, mb: 2, p: 2 }}>
          We sent you an email with the required actions to resolve in order to
          proceed with the incorporation.{' '}
          <strong>Please check your email</strong> for the details.
        </Alert>
      )}
      <UserPreferenceSetting
        email={email ?? ''}
        userId={userId}
        title="incorporation"
      />
    </Box>
  </Box>
);

interface Props {
  account: IAccount;
  business: Business;
}

export const IncorporationStatus = ({ account, business }: Props) => {
  const { userPreference, isLoading: isUserPrefLoading } =
    useUserPreference(account.ownerUserId);
  useAutoInitIncorporationStatus(business, business.progress ?? []);

  if (isUserPrefLoading) {
    return <Skeleton height={200} />;
  }

  if (
    business?.bibHubspot === undefined ||
    userPreference === undefined ||
    business?.entityType !== ENTITY_MAPPING.sole_prop
  ) {
    return null;
  }

  return (
    <IncorporationStatusUI
      email={account.ownerUserEmail}
      userId={account.ownerUserId}
      business={business}
    />
  );
};
